export enum CaseActionTypeEnum {
    SetSelectedCaseInfo = "SET_SELECTED_CASE_INFO",
    SetSelectedCaseMode = "SET_CASE_MODE",
    SetSelectedCase = "SET_SELECTED_CASE",
    SetCasePhase = "SET_SELECTED_CASE_PHASE",
    SetCaseSelectedTechnology = "SET_SELECTED_TECHNOLOGY",
    SetCaseSelectedConcept = "SET_SELECTED_CONCEPT",
    SetCaseSelectedEntity = "SET_SELECTED_ENTITY",
    SetCaseConceptTechnologyList = "SET_CONCEPT_TECHNOLOGY_LIST",
    UpdateTechSideNoteListAction = "UPDATE_TECHNOLOGY_SIDE_NOTE_LIST",
    UpdateTechnologyVoteAction = "UPDATE_TECHNOLOGY_VOTE",
    UpdateTechnologyRateAction = "UPDATE_TECHNOLOGY_RATE",
    SetCaseQueryCount = "SET_CASE_QUERY_COUNT"
}